function checkPelletByTime (obj,time) {
    const updatedAt = new Date(obj.updated_at);
    const now = new Date();
    const res = new Date(now.getTime() - time);
    return updatedAt >= res;
}
export default checkPelletByTime